import { css } from 'emotion';
import { Icon, Tooltip } from '@cimpress/react-components';
import { getDisplayStatus } from '../../../utilities/displayFunctions';
import React from 'react';
import { persimmon } from '@cimpress/react-components/lib/colors';

export const nameStyle = css({
  flex: '1',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden'
});

const ellipsisStyle = css({
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden'
});

export const contractDisplayStyle = css({
  display: 'flex',
  alignItems: 'center'
});

export const warningTextStyle = css({
  fontSize: '11px',
  color: persimmon.base
});

const ContractCard = ({ term }) => {
  return (
    <div className={contractDisplayStyle} key={term.termId}>
      <div className={nameStyle} title={term.additionalData.name}>
        <div className={ellipsisStyle}>{term.additionalData.name || 'No Contract Name'}</div>
        {!term.isLatestRevision && <span className={warningTextStyle}>(sku removed from latest revision)</span>}
      </div>
      {term.isTermEffective && (
        <Tooltip
          contents="Contract is in effect and being used to price this product."
          style={{ flexBasis: '20px', paddingBottom: '7px' }}>
          <div>
            <Icon name="rank-army-star-2-f" color={persimmon.base} />
          </div>
        </Tooltip>
      )}
      {
        getDisplayStatus({
          contractRevision: term,
          hasAcceptorPermission: term.userHasAuthorizationFor.acceptor
        }).labelRender
      }
    </div>
  );
};

export default ContractCard;
